import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { IBaryInput } from 'models/bary-input';
import { takeUntil } from 'rxjs/operators';
import { SubscribedContainer } from '../../util/subscribed-container';
import { CommonModule } from '@angular/common';
import { InputsModule, InputUtilitiesModule, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { MarkAsteriskDirective } from '../../../../directives/mark-asterisk.directive';
import { TranslateDirective } from '../../../../directives/translate.directive';
import { NumberUtil } from '../../util/number-util';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-input-number',
  templateUrl: './bary-input-number.component.html',
  styleUrls: ['./bary-input-number.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, InputUtilitiesModule, InputsModule, MDBBootstrapModulesPro, MarkAsteriskDirective, TranslateDirective, BaryIconComponent],
})
export class BaryInputNumberComponent extends SubscribedContainer implements OnInit, OnChanges, IBaryInput {
  @Input() id = '';
  @Input() label: string | undefined;
  @Input() icon: string | undefined;
  @Input() name: string | undefined;
  @Input() counter = false;
  @Input() disabled = false;
  @Input() min = 0;
  @Input() max = 999999999;
  @Input() placeholder = '';
  @Input() step = 1;
  @Input() keyTranslateMinError: string = 'components.inputs.errors.minNumber';
  @Input() keyTranslateMaxError: string = 'components.inputs.errors.maxNumber';
  @Input() control = new FormControl();
  @Input() transformFunction: any;
  @Input() maxDigits = 3;

  public _control!: FormControl;

  protected readonly FAR = FaDirectiveEnum.FAR;

  ngOnInit(): void {
    if (this.transformFunction) {
      this._control = new FormControl(this.transformFunction(this.control.value), { updateOn: 'blur' });
      this._control.setValidators(this.control.validator);

      this.control.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(newValue => {
        if (newValue != null) {
          if ('' + newValue !== '' + this._control.value) {
            this._control.setValue(this.transformFunction(newValue), { emitEvent: false });
          }
        } else {
          this._control.setValue(null, { emitEvent: false });
        }
      });
      this._control.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(newValue => this.control.setValue(NumberUtil.formatStringWithUnitToNumber(newValue, this.maxDigits)));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const change in changes) {
      if (change === 'id') {
        this.id = BaryComponentHelper.makeId();
      } else if (change === 'disabled') {
        if (changes['disabled'].currentValue) {
          this.control.disable({ onlySelf: true, emitEvent: false });
        } else {
          this.control.enable({ onlySelf: true, emitEvent: true });
        }
      }
    }
  }

  public checkValue($event: KeyboardEvent): boolean {
    if (($event.key < '0' || $event.key > '9') && $event.key !== '.' && $event.key !== ',') {
      $event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  public formatTextValue(): void {
    if (this.transformFunction) {
      const number = NumberUtil.formatStringWithUnitToNumber(this._control.value, this.maxDigits);
      this._control.setValue(this.transformFunction(number), { emitEvent: false });
    }
  }
}
